import { render, staticRenderFns } from "./RegionalNucleus-comp.vue?vue&type=template&id=2af4cd8f&"
import script from "./RegionalNucleus-comp.vue?vue&type=script&lang=js&"
export * from "./RegionalNucleus-comp.vue?vue&type=script&lang=js&"
import style0 from "./RegionalNucleus-comp.vue?vue&type=style&index=0&id=2af4cd8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports